import { restServices } from "../../../../cuba/services";

export const getStartFormDataQuery = (processDefinitionKey: string) => ({
  queryKey: ["startFormData", processDefinitionKey],
  queryFn: () =>
    restServices.bprocService.getStartFormData({ processDefinitionKey }),
});

export const getTaskFormDataQuery = (taskId: string) => ({
  queryKey: ["taskFormData", taskId],
  queryFn: () => restServices.bprocFormService.getTaskFormData({ taskId }),
});
